import React, { useState } from "react";

import BarSortingTutorial from "../../../components/Task/types/BarSorting/Tutorial";
import BarSorting2Tutorial from "../../../components/Task/types/BarSorting2/Tutorial";
import BarlineTutorial from "../../../components/Task/types/Barline/Tutorial";
import RhytSortingTutorial from "../../../components/Task/types/RhytSorting/Tutorial";
import MelodyTableTutorial from "../../../components/Task/types/MelodyTable/Tutorial";
import TonesetStaffTutorial from "../../../components/Task/types/TonesetStaff/Tutorial";
import FlowTutorial from "../../../components/Task/types/Flow/Tutorial";
import SingingTutorial from "../../../components/Task/types/Singing/Tutorial";
import RhytNameTutorial from "../../../components/Task/types/RhytName/Tutorial";
import RhytKnockTutorial from "../../../components/Task/types/RhytKnock/Tutorial";
import RhytNotationTutorial from "../../../components/Task/types/RhytNotation/Tutorial";
import SolfaNameTutorial from "../../../components/Task/types/SolfaName/Tutorial";
import HandSignTutorial from "../../../components/Task/types/HandSign/Tutorial";
import IntervalsTutorial from "../../../components/Task/types/Intervals/Tutorial";
import PianoTutorial from "../../../components/Task/types/Piano/Tutorial";
import EmbedTutorial from "../../../components/Task/types/Embed/Tutorial";
import Chords3Tutorial from "../../../components/Task/types/Chords3/Tutorial";
import SubScoreTutorial from "../../../components/Task/types/SubScore/Tutorial";

import { Button } from "../../../components/Tutorial";

import { IProps } from "./interfaces";

const TutorialContainer = ({ type, title }: IProps) => {
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    return (
        <>
            {open && (
                <>
                    {type === "barSorting" && (
                        <BarSortingTutorial close={handleClose} title={title} />
                    )}
                    {type === "barSorting2" && (
                        <BarSorting2Tutorial close={handleClose} title={title} />
                    )}
                    {type === "barline" && (
                        <BarlineTutorial close={handleClose} title={title} />
                    )}
                    {type === "rhytSorting" && (
                        <RhytSortingTutorial close={handleClose} title={title} />
                    )}
                    {type === "rhytName" && (
                        <RhytNameTutorial close={handleClose} title={title} />
                    )}
                    {type === "rhytKnock" && (
                        <RhytKnockTutorial close={handleClose} title={title} />
                    )}
                    {type === "subScore" && (
                        <SubScoreTutorial close={handleClose} title={title} />
                    )}
                    {type === "rhytNotation" && (
                        <RhytNotationTutorial close={handleClose} title={title} />
                    )}
                    {type === "melodyTable" && (
                        <MelodyTableTutorial close={handleClose} title={title} />
                    )}
                    {type === "tonesetStaff" && (
                        <TonesetStaffTutorial close={handleClose} title={title} />
                    )}
                    {type === "flow" && <FlowTutorial close={handleClose} title={title} />}
                    {type === "singing" && (
                        <SingingTutorial close={handleClose} title={title} />
                    )}
                    {type === "solfaName" && (
                        <SolfaNameTutorial close={handleClose} title={title} />
                    )}
                    {type === "handSign" && (
                        <HandSignTutorial close={handleClose} title={title} />
                    )}
                    {type === "intervals" && (
                        <IntervalsTutorial close={handleClose} title={title} />
                    )}
                    {type === "chords3" && (
                        <Chords3Tutorial close={handleClose} title={title} />
                    )}
                    {type === "piano" && (
                        <PianoTutorial close={handleClose} title={title} />
                    )}
                    {type === "embed" && (
                        <EmbedTutorial close={handleClose} title={title} />
                    )}
                </>
            )}
            <Button onClick={handleOpen} />
        </>
    );
};

export default TutorialContainer;
